<template>
  <div>
    <b-card-header header-class="aside-header pl-2">
      <strong>Plan Options</strong>
      <span
        class="fa fa-times-circle fa-lg close-icon"
        @click.stop="closeSettings"
      ></span>
    </b-card-header>
    <b-card body-class="p-2">
      <b-form-group>
        <label for="domain">Company</label>
        <b-form-input id="company" v-model="company" type="text"></b-form-input>
      </b-form-group>

      <b-form-group>
        <label for="domain">Domain</label>
        <b-form-input id="domain" v-model="domain" type="text"></b-form-input>
      </b-form-group>
      <b-form-group>
        <label for="domain"
          >Product URLs <span class="text-muted">(optional)</span></label
        >
        <b-form-input
          id="productUrls"
          v-model="productUrls"
          type="text"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <label for="domain"
          >Product Keywords <span class="text-muted">(optional)</span></label
        >
        <b-form-input
          id="productKeywords"
          v-model="productKeywords"
          type="text"
        ></b-form-input>
      </b-form-group>
      <!-- <b-form-group>
        <label for="domain"
          >Special Instructions
          <span class="text-muted">(optional)</span></label
        >
        <b-form-textarea
          id="specialInstructions"
          v-model="specialInstructions"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group> -->
      <b-form-group>
        <b-form-checkbox
          id="saveAsDefaultForUser"
          name="saveAsDefaultForUser"
          class=" rounded d-inline b-0 "
          placeholder="Save as default"
          v-model="saveAsDefaultForUser"
          ref="saveAsDefaultForUser"
        >
          <span class="col-form-label">Save as default on Refresh</span>
        </b-form-checkbox>
      </b-form-group>
      <b-form-group v-if="isClientAdmin">
        <b-form-checkbox
          id="saveAsDefaultForGroup"
          name="saveAsDefaultForGroup"
          class=" rounded d-inline b-0 "
          placeholder="Save as default for group"
          v-model="saveAsDefaultForGroup"
          ref="saveAsDefaultForGroup"
        >
          <span class="col-form-label">Save as default for Group </span>
        </b-form-checkbox>
      </b-form-group>
      <div>
        <hr class="mb-3" />

        <div class="text-center">
          <b-button
            variant="primary"
            size="sm"
            @click="rerunReport"
            :disabled="disableRefresh"
          >
            Refresh Plan
          </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'SalesAI',
  computed: {
    ...mapFields('SalesAi', [
      'company',
      'domain',
      'productUrls',
      'productKeywords',
      'specialInstructions',
      'saveAsDefaultForUser',
      'saveAsDefaultForGroup'
    ]),
    ...mapState('Ability', ['userRole']),
    isClientAdmin() {
      return this.userRole === 'Client Admin'
    },
    disableRefresh() {
      return this.company.trim() === '' || this.domain.trim() === ''
    }
  },
  methods: {
    ...mapMutations('SalesAi', ['setReportRerunStatus']),
    closeSettings() {
      document.body.classList.add('aside-menu-hidden')
      this.$store.dispatch('setAsideToogle', false)
    },
    rerunReport() {
      this.setReportRerunStatus(true)
    }
  }
}
</script>
